import { IconButton, IconButtonProps } from '@mui/material';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';
import { themeActions, themeSelectors } from '../redux/theme-slice';

export default function ToggleColorModeButton(props: IconButtonProps) {
    const paletteMode = useAppSelector(themeSelectors.paletteMode);
    const dispatch = useAppDispatch();

    const toggleColorMode = () => {
        dispatch(themeActions.togglePaletteMode());
    };

    return (
        <IconButton
            {...props}
            color="inherit"
            aria-label="toggle color mode"
            onClick={toggleColorMode}
        >
            {paletteMode === 'dark' ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
        </IconButton>
    );
}
